import React, { Fragment } from "react";
import { useTranslation } from "react-i18next";
import { Box } from "@mui/material";
import { MyHrHelpdeskContact, MyHrPublicLayoutLink } from "my-hr/components";
import { MyHrLoginForm, MyHrLoginSSOForm } from "my-hr/forms";
import { useOcIsMobile } from "oc/hooks/use-is-mobile";

interface MyHrLoginProps {
  onLogin: (data: any) => void;
  isSSO: boolean;
}

export const MyHrLogin: React.FC<MyHrLoginProps> = ({ onLogin, isSSO }) => {
  const { t } = useTranslation();
  const isMobile = useOcIsMobile();

  return (
    <Box>
      <Box>
        <Box id="orgware-logo">
          <img
            alt="orgware-icon"
            src="/img/owIconLogoColored.png"
            style={{ marginBottom: 30 }}
          />
        </Box>
        <Box id="orgware-text-logo">
          <img
            alt="orgware-icon"
            src="/img/owLogoColored.png"
            style={{ width: 300 }}
          />
        </Box>
      </Box>

      {isSSO && <MyHrLoginSSOForm onLogin={onLogin} />}
      {!isSSO && (
        <Fragment>
          <Box
            display="flex"
            flexDirection="column"
            alignItems="center"
            paddingTop={isMobile ? "0px" : "20px"}
          >
            <Box id="login-form" width="304px" padding="16px 48px">
              <MyHrLoginForm
                onSubmit={onLogin}
                buttonLabel={t("MY_HR_LOGIN")}
              />
            </Box>
            <Box paddingTop="18px">
              <MyHrPublicLayoutLink
                label={t("MY_HR_LINK_FORGOT_PASSWORD")}
                path="/forgot-password"
              />
            </Box>
            <Box height="36px" />
            <MyHrHelpdeskContact />
          </Box>
        </Fragment>
      )}
    </Box>
  );
};

export default MyHrLogin;
